import {AUTH_TOKEN_STORAGE_KEY, USER_ROLE_KEY} from "./constants/Constants";

export default class User {
    constructor() {
        this.token = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
        this.loginTime = localStorage.getItem("loginTime");
        this.role = USER_ROLE_KEY;
        this.gameID = "";
        this.teamId = "";
        this.availablePlayers = null
    }

    setToken(token) {
        console.trace()
        this.token = token;
        if (token == null) {
            localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
            localStorage.removeItem("loginTime");
        } else {
            localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token);

            // сохраняем timestamp логина
            localStorage.setItem("loginTime", Date.now().toString());
        }
    }

    getToken() {
        if (this.hasToken()) {
            return this.token;
        }
        let token = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
        if (token) {
            this.token = token;
            return this.token;
        }
        return null;
    }

    getLastLogin() {
        return this.loginTime;
    }

    hasToken() {
        if (!this.token)
            return false;
        return this.token !== "";
    }
}
